import React, { Component, Fragment } from 'react';

// Assets
import Logo from './../../assets/img/core/esuubi-logo.webp';
import Footer from './footer';

// Components


// Component class itself
class FullPageError extends Component {

    render() {

        return (
            <Fragment>
                <div className="error-screen">
                    <div className="width-6 centred">
                        <img src={Logo} alt="Esuubi Logo" />
                        <h1>Page not found</h1>
                        <p>Sorry, but it seems the page you&rsquo;re looking for either moved or never existed.</p>
                        <p>Please go back and try again</p>
                    </div>
                </div>
                <Footer />
            </Fragment>
        );

    }
}

export default FullPageError;